<template>
  <z-tooltip
    position="top"
    :disabled="!isContentClamped"
    :open-delay="openDelay"
    :transition="transition"
  >
    <template #activator="{on}">
      <div class="overflow-container" style="position: relative" v-on="on">
        <v-clamp
          autoresize
          :max-lines="maxLines"
          :style="contentStyles"
          :class="className"
        >
          {{ (content && content.toString()) || '' }}

          <template #before="{clamped}">
            <div
              style="
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                z-index: 1;
              "
              @mouseover="isContentClamped = clamped"
            >
              {{ '' }}
            </div>
          </template>
        </v-clamp>
      </div>
    </template>

    {{ content }}
  </z-tooltip>
</template>

<script>
import VClamp from 'vue-clamp'

export default {
  name: 'ZOverflowTooltip',
  components: {VClamp},

  props: {
    /**
     * Número máximo de linhas que o texto pode ter
     */
    maxLines: {
      type: Number,
      default: 1,
    },
    /**
     * Conteúdo a ser truncado e exibido no tooltip
     */
    content: {
      type: [String, Number],
      required: true,
      default: '',
    },

    /**
     * Objeto de estilos para o conteúdo
     */
    contentStyles: {
      type: Object,
      default: () => ({}),
    },
    /**
     * Classes para o conteúdo
     */
    className: {
      type: String,
      default: '',
    },

    /**
     * Delay para abrir o tooltip
     */
    openDelay: {
      type: Number,
      default: 0,
    },

    /**
     * Transição do tooltip
     */
    transition: {
      type: String,
      default: 'scale-transition',
    },
  },
  data() {
    return {
      isContentClamped: false,
    }
  },
}
</script>

<style scoped lang="scss">
.overflow-container > div {
  :deep(> span > span) {
    position: relative;
    z-index: 2;
  }
}
</style>
